// extracted by mini-css-extract-plugin
export default {"adContainer":"styles_adContainer__lA0y8","label":"styles_label__AKCqp","adWrapper":"styles_adWrapper__eA-2a"};